(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Breakpoint = module.exports = function(){
   this.calculateBreakpoint();
    $(window).on('resize',function(){
        $('body').addClass('resize');
        clearTimeout(this.wait);
        this.wait = setTimeout(function(){
            $('body').removeClass('resize');
        },1000);
        this.calculateBreakpoint();
    }.bind(this));
}

Breakpoint.prototype.calculateBreakpoint = function(){
    var currentBreakpoint = this.breakpoint;
    this.breakpoint = this.breakpoints[0].name;
    $(this.breakpoints).each(function(index, breakpoint){
        if (window.innerWidth > breakpoint.breakpoint){
            this.breakpoint = breakpoint.name;
        }
    }.bind(this));
    if (currentBreakpoint != this.breakpoint){
        var event = new CustomEvent('breakpoint', { 'detail': this.breakpoint });
        window.dispatchEvent(event);
    }
}

Breakpoint.prototype.breakpoints = [
    {breakpoint:0,      name:'xs'},
    {breakpoint:576,    name:'sm'},
    {breakpoint:768,    name:'md'},
    {breakpoint:992,    name:'lg'},
    {breakpoint:1200,   name:'xl'}
]
Breakpoint.prototype.breakpoint = 'xs';
Breakpoint.prototype.wait = null;
}).call(this,require("km4Umf"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_d21b6bad.js","/")